import { createContext } from 'react';

import { IAuth } from '@/modules/auth/types';
import { IAuthContext } from '@/shared/hooks/context/auth/IAuthContext';

const AuthContext = createContext<
  IAuthContext.IAuthContextProps<IAuth.IUser | null>
>({
  updateUser: (user) => user,
  comebackLogin: () => {
    return;
  },
  authenticated: false,
  login: (token) => token,
  logout: () => {
    return;
  },
  settings: {},
  token: null,
  user: null,
  userLoading: true,
  collapseState: true,

  onboardingChecks: null,
  updateOnboardingChecks: (checks) => checks,

  subscriptionType: null,
  updateSubscriptionType: (sub) => sub,

  updateCollapseState: (state) => state,
});

export default AuthContext;
